import { CosPaginatedGrid } from './common.js';

class CosArticles extends CosPaginatedGrid {
  // beforeUnload() {
  //   if (!this.paginate.current_page || this.paginate.current_page === 1) {
  //     this.resetStorage();

  //     return;
  //   }

  //   super.beforeUnload();
  // }
}
if (!customElements.get('cos-articles')) customElements.define('cos-articles', CosArticles);

(function(window, document) {
  'use strict';

  const renderArticle = ([title, url, imageUrl, imageAlt, date, excerpt, readingTime]) => {
    return `
      <li class="mb50">
        <div class="article__list-image-wrapper mb30 js">
          <a href="${url}" class="article__list-image-container images-wrap" style="padding-bottom: 50%;" title="${title}">
            <img
              class="article__list-image"
              src="${imageUrl}"
              alt="${imageAlt}"
              loading="lazy"
            >

            <small class="reading-time blue-light-bg">
              ${readingTime}
            </small>
          </a>
        </div>

        <h2 class="article__title h3 mb20"><a href="${url}" title="${title}">${title}</a></h2>

        <span class="article__date">
          ${date}
        </span>

        <div class="rte article__content">
          <p>${excerpt}</p>
        </div>
      </li>`
  };

  addEventListener('DOMContentLoaded', async () => {
    const articles = window.custom.articles || [];
    
    const articleList = document.querySelector('[article-list]');
    if (!articleList) return;

    articleList.innerHTML = articles.splice(0,10).map(renderArticle).join('');

    const loadMore = document.querySelector('[load-more]');      
    if (!loadMore) return;

    const loadMoreWrapper = document.querySelector('[load-more-wrapper]');
    if (articles.length === 0) {
      loadMoreWrapper.style.display = 'none';
      return;
    }
    
    loadMore.addEventListener('click', () => {
      
      articleList.innerHTML += articles.splice(0,10).slice(0,10).map(renderArticle).join('');

      if (articles.length === 0) {
        loadMoreWrapper.style.display = 'none';
      }
    });
  });
})(window, document);